module.exports = __webpack_public_path__ + "static/media/shubham.c024aaf6.jpg";